import React from "react";

import "./dropdown.css";

interface DropdownProps {
    prefix?: string;
    options: string[];
    selectedOption: number;
    setSelectedOption: (option: number) => void;
    rounded?: boolean;
}

export default function Dropdown(props: DropdownProps) {

    return <div className="dropdown">
        <a>{props.prefix ? props.prefix : ""}</a>
        <select className={props.rounded ? "round-button" : ""} value={props.selectedOption} onChange={(e) => props.setSelectedOption(parseInt(e.target.value))}>
            
            {props.options.map((option, index) => (
                <option key={index} value={index}>
                    {option}
                </option>
            ))}
        </select>
    </div>

}